import { Map } from '@vis.gl/react-google-maps'

import type { TLote } from '@/features/empreendimentos/http'
import { cn } from '@/infra'
import type { Coordinate, TGetBlocosResponse } from '@/types/blocos'

import { MapContent } from './map-content'
import { useGoogleMapOverlay } from './use-google-map-overlay'

const MAX_ZOOM_LEVEL = 22

export interface Region {
  latitude: number
  longitude: number
  latitudeDelta: number
  longitudeDelta: number
}

export interface ImageOverlayProps {
  uri: string
}

export interface GoogleMapWithImageOverlayProps {
  className?: string
  overlayCoordinates: [Coordinate, Coordinate]
  image: ImageOverlayProps
  lotes?: TLote[]
  quadras: TGetBlocosResponse['blocos']
  maxZoomLevel?: number
  onRegionChange?: (region: Region) => void
  onMapLoaded?: () => void
  onLotePress?: (lote: TLote) => void
  baseLatLngDelta: number
  initialRegion: Region
}

export const GoogleMapWithImageOverlay = ({
  className,
  overlayCoordinates,
  image,
  lotes = [],
  quadras,
  baseLatLngDelta,
  initialRegion,
  maxZoomLevel = MAX_ZOOM_LEVEL,
  onRegionChange,
  onMapLoaded,
  onLotePress,
}: GoogleMapWithImageOverlayProps) => {
  const { containerRef, minZoomLevel, currentZoom, handleCameraChange, initialCenter, restrictionBounds } =
    useGoogleMapOverlay({
      overlayCoordinates,
      quadras,
      initialRegion,
      baseLatLngDelta,
      onRegionChange,
    })

  return (
    <div ref={containerRef} className={cn('relative z-30 min-h-full w-full', className)}>
      {minZoomLevel !== null && currentZoom !== null && (
        <Map
          mapId="28ee7d761504884cde758b09"
          className="h-full w-full rounded border"
          defaultCenter={initialCenter}
          defaultZoom={minZoomLevel}
          minZoom={minZoomLevel}
          maxZoom={maxZoomLevel}
          restriction={{
            latLngBounds: restrictionBounds,
            strictBounds: false,
          }}
          gestureHandling="cooperative"
          disableDefaultUI={true}
          zoomControl={true}
          scrollwheel={true}
          disableDoubleClickZoom={false}
          clickableIcons={false}
          streetViewControl={false}
          fullscreenControl={false}
          mapTypeControl={false}
          rotateControl={false}
          scaleControl={false}
          keyboardShortcuts={false}
          onCameraChanged={handleCameraChange}
          onTilesLoaded={() => {
            if (onMapLoaded) {
              onMapLoaded()
            }
          }}
        >
          <MapContent
            overlayCoordinates={overlayCoordinates}
            imageUri={image.uri}
            lotes={lotes}
            onLotePress={onLotePress}
          />
        </Map>
      )}
    </div>
  )
}
